var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icones"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 27.3334H9.33341C5.33341 27.3334 2.66675 25.3334 2.66675 20.6667V11.3334C2.66675 6.66669 5.33341 4.66669 9.33341 4.66669H22.6667C26.6667 4.66669 29.3334 6.66669 29.3334 11.3334V20.6667C29.3334 25.3334 26.6667 27.3334 22.6667 27.3334Z",
    stroke: "#292B30",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6666 12L18.4932 15.3333C17.1199 16.4267 14.8666 16.4267 13.4932 15.3333L9.33325 12",
    stroke: "#292B30",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35",
    d: "M31.4999 5.33333C31.4999 8.00271 29.336 10.1667 26.6666 10.1667C23.9972 10.1667 21.8333 8.00271 21.8333 5.33333C21.8333 2.66396 23.9972 0.5 26.6666 0.5C29.336 0.5 31.4999 2.66396 31.4999 5.33333Z",
    fill: "#0073BB",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.88079d53960775553b55ca7d5349d944.svg";
export { ForwardRef as ReactComponent };